import { z } from "zod";

export const RequestFieldEffectDtoSchema = z.object({
    key: z.string(),
    visibility: z.boolean(),
    fill: z.boolean(),
    value: z.string().nullish(),
});

export type RequestFieldEffectDto = z.infer<typeof RequestFieldEffectDtoSchema>;
